import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'nospace' })
export class NoSpacePipe implements PipeTransform {
  transform(value: string, args: string[]): any {
    return (!value) ? '' : value.replace(/ /g, '');
  }
}
